import { Controller } from 'stimulus';
import gsap from 'gsap';
import { debounce } from 'lodash';
import dataLayer from '../tracking/dataLayer';

class Search extends Controller {
  connect() {
    this.isHidden = true;

    this.onDebouncedSearchChange = debounce(this.onSearchChange.bind(this), 600);

    if (this.hasInputTarget && this.inputTarget.value) {
      this.onSearchChange();
    }
  }

  onSearchChange() {
    const { value } = this.inputTarget;

    if (!value || !value.length) {
      this.fadeOutResults()
        .then(() => {
          this.resultsTarget.innerHTML = '';
        });
      return;
    }

    dataLayer.event('Search', 'change', value);

    if (this.isSearching) {
      return;
    }

    this.isSearching = true;

    // Hide current results
    this.fadeOutResults();

    const startTimeInSeconds = Date.now() / 1000;

    // Transform the tags from Tagify into the format accepted by the server
    Search.search({
      q: [value],
    })
      // Render new results
      .then((results) => {
        const endTimeInSeconds = Date.now() / 1000;
        const minDelayInSeconds = 3;

        const addedDelay = endTimeInSeconds - startTimeInSeconds < minDelayInSeconds
          ? minDelayInSeconds - (endTimeInSeconds - startTimeInSeconds)
          : 0;

        setTimeout(() => {
          this.resultsTarget.innerHTML = results;
          this.fadeInResults();
          this.isSearching = false;
        }, addedDelay);
      });
  }

  fadeOutResults(...params) {
    return new Promise((resolve) => {
      if (this.isHidden) {
        resolve.call(this, params);
        return;
      }

      gsap.to(this.resultsTarget, {
        opacity: 0,
        duration: 0.3,
        onComplete: () => {
          this.isHidden = true;
          resolve.call(this, params);
        },
      });
    });
  }

  fadeInResults(...params) {
    return new Promise((resolve) => {
      gsap.to(this.resultsTarget, {
        opacity: 1,
        onComplete: () => {
          this.isHidden = false;
          resolve.call(this, params);
        },
      });
    });
  }

  static search(query) {
    const params = new URLSearchParams();

    Object.keys(query).forEach((key) => {
      const val = query[key];

      if (Array.isArray(val)) {
        val.forEach((item) => {
          params.append(`${key}[]`, item);
        });
      } else {
        params.append(key, val);
      }
    });

    return new Promise((resolve) => {
      fetch(`${window.app.api.search}?${params}`)
        .then((res) => res.text())
        .then((res) => {
          resolve(res);
        });
    });
  }
}

Search.targets = [
  'results',
  'input',
];

export default Search;
